import { callApi, fetchApi, postApi, requestApi } from '@/api';

function unsupported(operation) {
  throw new Error(`HttpApiLicenseRepository does not implement ${operation} yet`);
}

export class HttpApiLicenseRepository {
  mapMarkers(cityId) {
    return fetchApi(`/v1/cities/${encodeURIComponent(cityId)}/license-markers`);
  }

  async searchLicenses(cityId, options) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/licenses/search`, options);
  }

  async exportLicenses(cityId, options) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/licenses/export`, options);
  }

  async createLicense(cityId, payload) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/licenses`, payload);
  }

  async updateLicense(cityId, licenseId, payload) {
    return requestApi(`/v1/cities/${encodeURIComponent(cityId)}/licenses/${encodeURIComponent(licenseId)}`, {
      method: 'PUT',
      body: payload
    });
  }

  async updateLicenseId(cityId, licenseId, payload) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/licenses/${encodeURIComponent(licenseId)}/license-id`, payload);
  }

  async updateLicenseProperty(cityId, licenseId, payload) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/licenses/${encodeURIComponent(licenseId)}/property`, payload);
  }

  async updateLicenseContact(cityId, licenseId, payload) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/licenses/${encodeURIComponent(licenseId)}/applicant`, payload);
  }

  async updateLicenseApplicationAnswers(cityId, licenseId, payload) {
    return requestApi(`/v1/cities/${encodeURIComponent(cityId)}/licenses/${encodeURIComponent(licenseId)}/application-answers`, {
      method: 'PATCH',
      body: payload
    });
  }

  async updateLicenseStatusAndDates(cityId, licenseId, payload) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/licenses/${encodeURIComponent(licenseId)}/status-dates`, payload);
  }

  async saveLicense() {
    unsupported('saveLicense');
  }

  async deleteLicense() {
    unsupported('deleteLicense');
  }

  async updateLicenseApplication() {
    unsupported('updateLicenseApplication');
  }

  async addReport() {
    unsupported('addReport');
  }

  async importLicenses(cityId, payload) {
    return callApi('importLicenses', {
      cityId,
      ...payload
    }, 'data');
  }
}
